import React from 'react';
import { makeStyles, useMediaQuery } from '@material-ui/core';
import { designTokens } from '../../styles/designTokens';
import Button from '../Button';

const useStyles = makeStyles({
    root: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '1200px',
        margin: '0 auto',
    },
    summarySection: {
        paddingBottom: designTokens.spacing.lg,
    },
    summaryRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '8px',
        '&:last-child': {
            marginBottom: 0,
        }
    },
    summaryLabel: {
        ...designTokens.typography.body,
        color: designTokens.colors.text.secondary,
    },
    summaryValue: {
        ...designTokens.typography.body,
        color: designTokens.colors.text.primary,
    },
    totalLabel: {
        ...designTokens.typography.h3,
    },
    totalValue: {
        ...designTokens.typography.h3,
    },
    buttonsRow: {
        display: 'flex',
        justifyContent: 'center',
        gap: '16px',
        '@media (max-width: 900px)': {
            flexDirection: 'column',
            justifyContent: 'stretch',
            alignItems: 'center',
            gap: '8px',
        }
    },
    buttonWrapper: {
        maxWidth: '300px',
        flex: 1,
        '@media (max-width: 900px)': {
            width: '300px',
            flex: 'none',
        }
    }
});

const CartSummary = ({
    totalPrice = 0,
    companyPayment = 0,
    patientPayment = 0,
    onClearAll,
    onCreateOrder,
    disabled = false,
    isLoading = false
}) => {
    const classes = useStyles();
    const isMobile = useMediaQuery('(max-width: 900px)');

    const total = parseFloat(totalPrice) || 0;
    const companyAmount = parseFloat(companyPayment) || 0;
    const patientAmount = parseFloat(patientPayment) || 0;
    const isOverLimit = companyAmount > total || patientAmount > total;

    const displayCompany = isOverLimit ? 0 : companyAmount;
    const displayPatient = isOverLimit ? 0 : Math.max(0, total - companyAmount);
    const showBreakdown = isOverLimit || companyAmount > 0;

    return (
        <div className={classes.root}>
            <div className={classes.summarySection}>
                {showBreakdown && (
                    <>
                        <div className={classes.summaryRow}>
                            <span className={classes.summaryLabel}>Оплата страховою:</span>
                            <span className={classes.summaryValue}>{displayCompany.toFixed(2)} грн</span>
                        </div>
                        <div className={classes.summaryRow}>
                            <span className={classes.summaryLabel}>Оплата пацієнта:</span>
                            <span className={classes.summaryValue}>{displayPatient.toFixed(2)} грн</span>
                        </div>
                    </>
                )}
                <div className={classes.summaryRow}>
                    <span className={classes.totalLabel}>{showBreakdown ? 'Повна вартість:' : 'До сплати:'}</span>
                    <span className={classes.totalValue}>{total.toFixed(2)} грн</span>
                </div>
            </div>

            <div className={classes.buttonsRow}>
                <div className={classes.buttonWrapper}>
                    <Button
                        variant="danger"
                        onClick={onClearAll}
                        size={isMobile ? 'small' : 'default'}
                    >
                        Відмінити все
                    </Button>
                </div>
                <div className={classes.buttonWrapper}>
                    <Button
                        variant="primary"
                        onClick={onCreateOrder}
                        disabled={disabled || isLoading}
                        size={isMobile ? 'small' : 'default'}
                    >
                        {isLoading ? 'Створення...' : 'Створити запис'}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default CartSummary;
